import * as React from "react";

function SvgDroplet(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 28 32"
      {...props}
    >
      <path
        d="M13.993 0c.667 0 1.302.276 1.743.758C19.488 4.818 28 11.213 28 18.51 28 25.96 21.732 32 14 32S0 25.96 0 18.51C0 11.213 8.498 4.805 12.25.758A2.363 2.363 0 0113.993 0zm.049 2.066a.227.227 0 00-.182.082c-.826.795-1.778 1.726-2.8 2.697C7.28 8.501 2.1 13.492 2.1 18.51c-.083 3.1 1.132 6.101 3.37 8.33 2.238 2.227 5.312 3.494 8.53 3.514 3.218-.02 6.292-1.287 8.53-3.515 2.238-2.228 3.453-5.229 3.37-8.329 0-5.018-5.25-10.009-8.89-13.665a43.037 43.037 0 01-2.8-2.697.2.2 0 00-.168-.082zM20.3 18.213c.577.008 1.043.456 1.05 1.012-.007 3.908-3.294 7.075-7.35 7.082-.58 0-1.05-.453-1.05-1.012 0-.558.47-1.011 1.05-1.011 2.897-.008 5.243-2.268 5.25-5.059 0-.559.47-1.012 1.05-1.012z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgDroplet;
